import React from 'react';
import Header from './Header';
import Footer from './Footer';
import ServiceUsageSimulator from './ServiceUsageSimulator';

const Layout = ({ children, title }) => {
  return (
    <div className="flex flex-col min-h-screen bg-gray-50 relative">
      <Header />
      {/* Espaciado para el header fijo */}
      <div className="h-20" />
      <main className="flex-grow flex flex-col">
        {title && (
          <div className="container mx-auto px-4 py-8">
            <h1 className="text-4xl font-display font-bold gradient-text">{title}</h1>
          </div>
        )}
        <div className="flex-grow">
          {children}
        </div>
      </main>
      <Footer />
      <ServiceUsageSimulator />
    </div>
  );
};

export default Layout;